import { companyPolicyConstants } from '../../_constants';
import { companyPolicyServices } from '../../_services';
import { alertActions, confirmPromptActions, userActions, } from '../index';

export const companyPolicyActions = {
    getAllCompanyPolicies,
    getCompanyPolicies,
    createCompanyPolicy,
    updateCompanyPolicy,
    getCompanyPolicyById,
    deleteCompanyPolicies,
    activation,
    searchCompanyPolicies,
    getCompanyPoliciesByCode,
    getCompanyPolicyReadListByCode
};

function fetching() { return { type: companyPolicyConstants.COMPANY_FETCHING } }
function fetched() { return { type: companyPolicyConstants.COMPANY_FETCHED } }

function submiting() { return { type: companyPolicyConstants.COMPANY_SUBMITING } }
function submited() { return { type: companyPolicyConstants.COMPANY_SUBMITED } }

function getCompanyPoliciesByCode() {
    return dispatch => {
        dispatch(fetching());
        companyPolicyServices.getCompanyPoliciesByCode()
            .then(
                companyPolicies => {
                    dispatch(success(companyPolicies))
                    dispatch(fetched());
                },
                error => {
                    dispatch(alertActions.error(error.toString()))
                    dispatch(fetched());
                }
            );
    };
    function success(companyPolicies) { return { type: companyPolicyConstants.GET_ALL_COMPANY_POLICIES, companyPolicies } }
}

function getAllCompanyPolicies() {
    return dispatch => {
        dispatch(fetching());
        dispatch(userActions.allowLeavePage());
        companyPolicyServices.getAllCompanyPolicies()
            .then(
                companyPolicies => {
                    dispatch(success(companyPolicies))
                    dispatch(fetched());
                },
                error => {
                    dispatch(alertActions.error(error.toString()))
                    dispatch(fetched());
                }
            );
    };
    function success(companyPolicies) { return { type: companyPolicyConstants.GET_ALL_COMPANY_POLICIES, companyPolicies } }
}

function getCompanyPolicies(skip, take) {
    return dispatch => {
        dispatch(fetching());
        dispatch(userActions.allowLeavePage());
        companyPolicyServices.getCompanyPolicies(skip, take)
            .then(
                companyPolicies => {
                    if (companyPolicies.length > 0) {
                        dispatch(success(companyPolicies));
                        dispatch(fetched());
                    } else {
                        dispatch(fetched());
                        dispatch(alertActions.warning('No more data to load'))
                    }
                },
                error => {
                    dispatch(fetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(companyPolicies) { return { type: companyPolicyConstants.GET_COMPANY_POLICIES, companyPolicies } }
}

function createCompanyPolicy(companyPolicy, userProfile) {
    return dispatch => {
        dispatch(submiting());
        dispatch(userActions.notallowLeavePage());
        companyPolicyServices.createCompanyPolicy(companyPolicy, userProfile)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(alertActions.success('Company policy added successfully'));
                    dispatch(submited());
                    window.location.href = '/master_data/company_policies';
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(submited());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}

function updateCompanyPolicy(companyPolicy, userProfile) {
    return dispatch => {
        // dispatch(updateArea(companyPolicy));
        dispatch(submiting());
        dispatch(userActions.notallowLeavePage());
        companyPolicyServices.updateCompanyPolicy(companyPolicy, userProfile)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(alertActions.success('Company policy updated successfully'));
                    dispatch(submited());
                    window.location.href = '/master_data/company_policies';
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(submited());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    // function updateArea() { return { type: companyPolicyConstants.UPDATE_COMPANY_POLICY } }
}

function getCompanyPolicyById(id) {
    return dispatch => {
        dispatch(fetching());
        dispatch(userActions.allowLeavePage());
        companyPolicyServices.getCompanyPolicyById(id)
            .then(
                companyPolicy => {
                    dispatch(fetched());
                    dispatch(success(companyPolicy))
                },
                error => {
                    dispatch(fetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(companyPolicy) { return { type: companyPolicyConstants.GET_COMPANY_POLICY_BY_ID, companyPolicy } }
}

function getCompanyPolicyReadListByCode(code) {
    return dispatch => {
        dispatch(fetching());
        dispatch(userActions.allowLeavePage());
        companyPolicyServices.getCompanyPolicyReadListByCode(code)
            .then(
                companyPolicy => {
                    dispatch(success(companyPolicy));
                    dispatch(fetched());
                },
                error => {
                    dispatch(fetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(companyPolicy) { return { type: companyPolicyConstants.GET_COMPANY_POLICY_BY_ID, companyPolicy } }
}

function deleteCompanyPolicies(id, type, take) {
    return dispatch => {
        dispatch(fetching());
        dispatch(userActions.notallowLeavePage());
        companyPolicyServices.deleteCompanyPolicies(id)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.success('Company policies deleted successfully'));
                    switch (type) {
                        case "specific":
                            window.location.href = '/master_data/company_policies';
                            break;
                        default:
                            dispatch(getAllCompanyPolicies());
                            break;
                    }
                    dispatch(fetched());
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(fetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}

function activation(code, id, isActive) {
    return dispatch => {
        dispatch(fetching());
        dispatch(userActions.notallowLeavePage());
        companyPolicyServices.activation(id, isActive)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(fetched());
                    dispatch(confirmPromptActions.hide());
                    dispatch(getCompanyPolicyReadListByCode(code));
                    dispatch(alertActions.success(isActive ? 'Company policy activated successfully' : 'Company policy deactivated successfully'))
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(fetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
}

function searchCompanyPolicies(take, filter, search) {
    return dispatch => {
        dispatch(fetching());
        companyPolicyServices.searchCompanyPolicies(take, filter, search)
            .then(
                companyPolicies => {
                    dispatch(searchCompanyPolicies(companyPolicies))
                    dispatch(fetched());
                },
                error => {
                    dispatch(fetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function searchCompanyPolicies(companyPolicies) { return { type: companyPolicyConstants.SEARCH_COMPANY_POLICIES, companyPolicies } }
}